import { render } from "./OrbitModuleCards.vue?vue&type=template&id=37955eb6&scoped=true"
import script from "./OrbitModuleCards.vue?vue&type=script&lang=js"
export * from "./OrbitModuleCards.vue?vue&type=script&lang=js"

import "./OrbitModuleCards.vue?vue&type=style&index=0&id=37955eb6&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37955eb6"]])

export default __exports__